import { useState } from "react";
import "./Contact.css";
import { useTranslation } from "react-i18next";

export default function Contact() {
  // États des champs
  const { t } = useTranslation("contact");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  // États de feedback
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null); // true = ok, false = erreur

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);

    try {
      const res = await fetch("http://localhost:4000/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ firstName, lastName, email, message }),
      });

      if (res.ok) {
        setSuccess(true);
        // Reset champs
        setFirstName("");
        setLastName("");
        setEmail("");
        setMessage("");
      } else {
        setSuccess(false);
      }
    } catch (err) {
      console.error(err);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact">
      <h2 className="contact-title">{t("title")}</h2>

      <form className="contact-form" onSubmit={handleSubmit}>
        {/* Prénom */}
        <div className="search-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder={t("placeholders.firstName")}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>

        {/* Nom */}
        <div className="search-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder={t("placeholders.lastName")}
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>

        {/* Email */}
        <div className="search-wrapper">
          <input
            type="email"
            className="search-input"
            placeholder={t("placeholders.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Message */}
        <div className="search-wrapper">
          <textarea
            className="search-input textarea"
            placeholder={t("placeholders.message")}
            rows="5"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>
        </div>

        {/* Bouton envoyer */}
        <button type="submit" className="contact-btn" disabled={loading}>
          {loading ? t("button.sending") : t("button.send")}
        </button>
      </form>

      {/* Feedback utilisateur */}
      {success === true && (
        <p style={{ color: "lightgreen", marginTop: "16px" }}>
         {t("feedback.success")}
        </p>
      )}
      {success === false && (
        <p style={{ color: "salmon", marginTop: "16px" }}>
          {t("feedback.error")}
        </p>
      )}
    </section>
  );
}
